module.exports = __webpack_public_path__ + "45016c6f89a38e725b706c931f831eb1.pdf";